export type ActivityFundTab = 'expenses' | 'contributions' | 'extra'

const TABS: readonly ActivityFundTab[] = ['expenses', 'contributions', 'extra']

export function parseActivityFundTab(search: string): ActivityFundTab {
  const tab = new URLSearchParams(search).get('tab')
  return TABS.find((t) => t === tab) ?? 'expenses'
}

/** The search string for `tab`, keeping every other parameter. */
export function activityFundTabSearch(search: string, tab: ActivityFundTab): string {
  const params = new URLSearchParams(search)
  if (tab === 'expenses') params.delete('tab')
  else params.set('tab', tab)
  const next = params.toString()
  return next ? `?${next}` : ''
}
